import MinMaxSettings from '@/pages/inventory/minMaxSetting/MinMaxView';
import MinMaxReportView from '@/pages/inventory/minMaxReport/MinMaxReportView';

const inventoryRoutes = [
  { path: 'inventory-min-max-setting', element: MinMaxSettings },
  { path: 'inventory-min-max-maintenance-report', element: MinMaxReportView },
];

export default inventoryRoutes;
